import React, { useEffect, useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import StarRatingWithComment from "./StarRatingWithComment";
import boschLogo from '../assets/bosch.png';

const BookReviewModal = (props: any) => {
  return (
    <>
      <Modal
        show={props.show}
        onHide={props.handleClose}
        backdrop="static"
        keyboard={false}
        id="accessibility-modal"
        centered
      >
        <Modal.Header closeButton style={{ paddingBottom: 0 }}></Modal.Header>
        <Modal.Body className="modal-body">
          <div className="modal-title">
                      <Modal.Title style={{ justifyContent:'left' }}>Review</Modal.Title>
                    </div>
        <StarRatingWithComment
                bookId={props.book._id}
                submitReview={props.submitReview}
              />
              <div className="my-8 w-[100%] d-flex flex-wrap justify-end px-8">
            <img src={boschLogo} alt="Bosch logo" className="w-[6.25rem]" />
            <p className="font-semibold my-3" style={{ width:'100%',justifyContent:'flex-end'}}>
              Accessibility conversion supported by bosch
            </p>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default BookReviewModal;
